import Swal from "sweetalert2"
import faradayApi from "../../api/faradayApi"


export const addVehicle = async (formValues, succesMsg, errorMsg, dupNameMsg, navigate) => {

    try {
        const {data} = await faradayApi.post('/vehicle', formValues)
        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            navigate('/vehicle')
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        console.log(error.response.data.msg)
        if (error.response.data.msg === 'name must be unique'){
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: dupNameMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: error,
                icon: "error",
                iconColor: '#FF7765'
            })
        }
        return false
    }
}

export const editVehicle = async (formValues, succesMsg, errorMsg, dupNameMsg) => {

    try {

        const { data } = await faradayApi.put('/vehicle', formValues)

        if (data.status === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${formValues.name} ${succesMsg}`,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }

    } catch (error) {
        console.error(error.response.data.msg)
        console.error(error)
        if (error.response.data.msg === 'name must be unique'){
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: dupNameMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
        }
        return false
    }
}

export const deleteVehicle = async (e, succesMsg, errorMsg, cancelButton, confirmButton, deleteConfirm ) => {
    const {value} = await Swal.fire({
        text: `${deleteConfirm} ${e.row.name}`,
        showCancelButton: true,
        confirmButtonColor: '#001B60',
        cancelButtonText: cancelButton,
        confirmButtonText: confirmButton,
        reverseButtons: true
      })
    value && onConfirm(e.row.id, succesMsg, errorMsg, e.row.name)
}

const onConfirm = async (id, succesMsg, errorMsg, name) => {
    const { data } = await faradayApi.delete('/vehicle', { data: { id } });

        data.data !== 0 && !data.error  ?
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${name} ${succesMsg}`,
                icon: "success",
            })
            :
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
            })       
}